// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__MCEDv","loader":"loader_loader__ASHvh","up-down6":"loader_up-down6__-Whlx","text":"loader_text__lp8G2"};